// Get all .wav files from the Sounds directory
const soundModules = import.meta.glob('../Sounds/*.wav', { eager: true, query: '?url', import: 'default' });

// Create the sounds object in the format you need
export const sounds: { [key: string]: string } = {};

for (const path in soundModules) {
  // Extract the filename from the full path (e.g., '../Sounds/bell.wav' -> 'bell.wav')
  const fileName = path.split('/').pop();
  if (fileName) {
    sounds[fileName] = soundModules[path] as string;
  }
}

export const NotificationSoundMap: { [key: string]: string } = Object.freeze({
  default: 'Default',
  no_sound: 'No Sound',
  'a_tone_his_self_1266414414.wav': 'A Tone',
  'appear_kp_1137861048.wav': 'Appear',
  'tx81z_papal_bell_c1.wav': 'Bell 1',
  'tx81z_papal_bell_c5.wav': 'Bell 2',
  'electronic_chime_kevangc_495939803.wav': 'Chime',
  'cow_and_bell_1243222141.wav': 'Cow and Bell',
  'cuckoo_clock_1776874523.wav': 'Cuckoo Clock',
  'mgf_99_eglitch_17.wav': 'Ding',
  'dream_harp_06.wav': 'Dream Harp',
  'fire_pager_jason_1283464858.wav': 'Fire Pager',
  'hermit_thrush_912282438.wav': 'Hermit Thrush',
  'computer_magic_microsift_1901299923.wav': 'Magic',
  'magic_chime_01.wav': 'Magic Chime',
  'music_box_big_daddy_1389738694.wav': 'Music Box',
  'open_soda_can_kp_1219969174.wav': 'Open Soda Can',
  'pling_kevangc_1485374730.wav': 'Pling',
  'mgf_99_ajvhs_20.wav': 'Power Down',
  'power_up_kp_1879176533.wav': 'Power Up',
  'bell_ringing_05.wav': 'Ringing',
  'stapler_374581609.wav': 'Stapler',
  'computer_start_up_1280862923.wav': 'Start Up 1',
  'imac_startup_chime_carlo__1849294605.wav': 'Start Up 2',
  'electrical_sweep_sweeper_1760111493.wav': 'Sweep',
  'telephone_ring_03a.wav': 'Telephone Ring',
  'tinkle_lisa_redfern_1916445296.wav': 'Twinkle',
  'ufo_landing_1015457638.wav': 'UFO Landing',
});
